import { useContext, useEffect, useState } from 'react'
import {
  InlineConnectionContext,
  UPDATE_CHANGE_INLINE_CONNECTION_DATA,
} from '../context/context'
import SelectInput from '../../../common/SelectInput'
import { getRequest, postRequest, putRequest } from '../../../../services/base'
import { useParams } from 'react-router-dom'
import InputText from '../../../common/InputText'
import Button from '../../../common/Button'
import { NavContext } from '../../../../context/global_context'
import useDebouncedValue from '../../../../utils/common_function'

const InlineConnectionsForm = (props) => {
  let { vehicle } = useParams()
  const [inlineState, inlineDispatch] = useContext(InlineConnectionContext)
  const [navState, navDispatch] = useContext(NavContext)

  const [fromConnectors, setFromConnectors] = useState([])
  const [toConnectors, setToConnectors] = useState([])
  const [inlineConnectionObj, setInlineConnectionObj] = useState({
    from_id: {},
    to_id: {},
    from_suffix: '',
    to_suffix: '',
    from_prefix: '',
    to_prefix: '',
    index: null,
  })
  const [searchToConnector, setSearchToConnector] = useState('')
  const debouncedToSearchConnector = useDebouncedValue(searchToConnector, 1000)
  const [searchFromConnector, setSearchFromConnector] = useState('')
  const debouncedFromSearchConnector = useDebouncedValue(
    searchFromConnector,
    1000
  )

  useEffect(() => {
    getConnectorsData(searchToConnector, 'to')
  }, [debouncedToSearchConnector])

  useEffect(() => {
    getConnectorsData(searchFromConnector, 'from')
  }, [debouncedFromSearchConnector])

  useEffect(() => {
    if (inlineState.selectedObject?.id) {
      setInlineConnectionObj(inlineState.selectedObject)
    }
  }, [inlineState.selectedObject])

  const getConnectorsData = async (value = '', type = '') => {
    let res = await getRequest(
      `/api/inline_connection/connectors/?vehicle=${vehicle}&search=${value}&limit=10`
    )
    if (type == 'both') {
      setFromConnectors(res.data)
      setToConnectors(res.data)
    } else if (type == 'to') {
      setToConnectors(res.data)
    } else if (type === 'from') {
      setFromConnectors(res.data)
    }
  }

  const saveInlineConnections = async (e) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Saving Inline Connections',
        showLoader: true,
      },
      notification: {},
    })

    const formData = new FormData(e.target)
    formData.append('vehicle', vehicle)
    let res = null
    if (inlineState.selectedObject?.id) {
      res = await putRequest(
        `/api/inline_connection/${inlineState.selectedObject?.id}/?vehicle=${vehicle}`,
        formData
      )
      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Inline Connections Updated Successfully',
          },
        })
        inlineDispatch({
          type: UPDATE_CHANGE_INLINE_CONNECTION_DATA,
          data: { ...res.data, index: inlineConnectionObj.index },
        })
        props.onSave()
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
    } else {
      res = await postRequest(
        `/api/inline_connection/?vehicle=${vehicle}`,
        formData
      )
      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Inline Connections Saved Successfully',
          },
        })
        props.getListData()
        props.onSave()
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
    }
  }

  return (
    <div className="">
      <form
        onSubmit={(e) => {
          e.preventDefault()
          saveInlineConnections(e)
        }}
      >
        <input
          type="hidden"
          value={inlineState?.selectedObject?.id ? false : true}
          name="is_create"
        />
        {inlineState?.selectedObject?.id && (
          <input
            type="hidden"
            name="id"
            value={inlineState?.selectedObject?.id}
          />
        )}
        <input
          type="hidden"
          name="import_file"
          value={
            inlineState?.selectedObject?.import_file
              ? inlineState?.selectedObject?.import_file
              : null
          }
        />

        <div className="flex justify-between">
          <SelectInput
            value={
              inlineConnectionObj?.from_id?.id
                ? inlineConnectionObj?.from_id
                : null
            }
            onChange={(value) => {
              setInlineConnectionObj({ ...inlineConnectionObj, from_id: value })
            }}
            label="From Connector"
            name="from_id"
            options={fromConnectors}
            optionLabel={'name'}
            optionValue={'id'}
            onInputChange={(value) => {
              setSearchFromConnector(value)
            }}
            className={`w-6/12`}
          />
        </div>
        <div className="flex justify-between">
          <SelectInput
            value={
              inlineConnectionObj?.to_id?.id ? inlineConnectionObj?.to_id : null
            }
            onChange={(value) => {
              setInlineConnectionObj({ ...inlineConnectionObj, to_id: value })
            }}
            label="To Connector"
            name="to_id"
            options={toConnectors}
            optionLabel={'name'}
            optionValue={'id'}
            onInputChange={(value) => {
              setSearchToConnector(value)
            }}
          />
        </div>
        <div className="flex justify-between">
          <InputText
            label={`From Suffix`}
            name="from_suffix"
            value={inlineConnectionObj?.from_suffix}
            isRequired={false}
            type="text"
          />
          <InputText
            label={`To Suffix`}
            name="to_suffix"
            value={inlineConnectionObj?.to_suffix}
            isRequired={false}
            type="text"
          />
        </div>
        <div className="flex justify-between">
          <InputText
            label={`From Prefix`}
            name="from_prefix"
            value={inlineConnectionObj?.from_prefix}
            isRequired={false}
            type="text"
          />
          <InputText
            label={`To Prefix`}
            name="to_prefix"
            value={inlineConnectionObj?.to_prefix}
            isRequired={false}
            type="text"
          />
        </div>
        <div className="flex justify-end">
          <div className="w-1/3 px-2">
            <Button
              type="submit"
              className={`cursor-pointer btn my-4 w-full justify-end pr-2`}
              onClick={(e) => {}}
              value={'text'}
              text={'Save Inline Connections'}
            />
          </div>
        </div>
      </form>
    </div>
  )
}

export default InlineConnectionsForm
